module.exports = __webpack_public_path__ + "img/login_avatar.9db13f4f.gif";